import { createTheme } from '@material-ui/core/styles';

const grey = '#979797';
const green = '#BFDA1C';
const ghostButton = 'rgba(0,0,0,0.6)';
const ghostStateFill = 'rgba(92,92,92,0.4)';
const ghostStats = 'rgba(92,92,92,0.25)';
const transparent = 'rgba(92,92,92,0)';
const background = '#1B1212';

export default createTheme({
  palette: {
    common: {
      grey,
      green,
      ghostButton,
      ghostStateFill,
      ghostStats,
      background
    },
    primary: {
      main: transparent
    }
  },
  typography: {
    h1: {
      fontFamily: 'neuePlakR',
      letterSpacing: '.06rem',
      fontSize: '1.875rem',
      lineHeight: '1.875rem',
      color: '#fff'
    },
    h2: {
      fontFamily: 'neuePlakB',
      letterSpacing: '.4rem',
      fontSize: '1.25rem',
      lineHeight: '3.75rem',
      color: '#fff'
    },
    body1: {
      fontFamily: 'neuePlakR',
      letterSpacing: '.1rem',
      fontSize: '1.125rem',
      lineHeight: '2.5rem',
      color: '#fff'
    },
    body2: {
      fontFamily: 'neuePlakR',
      letterSpacing: '.09rem',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      color: '#fff'
    },
    subhead1: {
      fontFamily: 'neuePlakB',
      fontSize: '1.25rem',
      letterSpacing: '.41rem',
      lineHeight: '2.25rem'
    },
    subhead2: {
      fontFamily: 'neuePlakR',
      letterSpacing: '.06rem',
      fontSize: '.875rem',
      lineHeight: '1.75rem'
    },
    subhead3: {
      fontFamily: 'neuePlakB',
      fontSize: '.875rem',
      letterSpacing: '.41rem',
      lineHeight: '1.375rem'
    },
    subhead5: {
      fontFamily: 'neuePlakB',
      fontSize: '1rem',
      lineHeight: '1.75rem',
      letterSpacing: '.125rem'
    },
    stat1: {
      fontFamily: 'neuePlakR',
      fontSize: '5.375rem',
      lineHeight: '5.375rem',
      letterSpacing: '0.06rem'
    },
    stat2: {
      fontFamily: 'neuePlakR',
      fontSize: '1.125rem',
      lineHeight: '2rem',
      letterSpacing: '.125rem'
    },
    button: {
      fontFamily: 'neuePlakB',
      fontSize: '.875rem',
      lineHeight: '.875rem',
      letterSpacing: '.1875rem'
    },
    button2: {
      fontFamily: 'neuePlakR',
      fontSize: '1.125rem'
    },
    caption: {
      fontFamily: 'neuePlakR',
      fontSize: '.75rem',
      lineHeight: '1rem',
      letterSpacing: '.06rem',
      color: '#979797'
    },
    episodeTitle: {
      fontFamily: 'neuePlakB',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      letterSpacing: '.06rem',
      color: '#fff'
    },
    episodeTitle2: {
      fontFamily: 'neuePlakB',
      fontSize: '1.25rem',
      lineHeight: '3.75rem',
      letterSpacing: '.4rem',
      color: green
    },
    navTab1: {
      fontFamily: 'neuePlakR',
      fontSize: '1rem',
      color: '#6F7373',
      letterSpacing: 0,
      lineHeight: '1.2rem'
    },
    label3: {
      fontFamily: 'neuePlakB',
      fontSize: '0.625rem',
      lineHeight: '1.25rem',
      letterSpacing: ' 0.09rem'
    },
    mobile: {
      h1: {
        fontFamily: 'neuePlakR',
        letterSpacing: '.06rem',
        fontSize: '1.5rem',
        lineHeight: '2.5rem',
        color: '#fff'
      },
      h2: {
        fontFamily: 'neuePlakB',
        letterSpacing: '.4rem',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        color: '#fff'
      },
      body1: {
        fontFamily: 'neuePlakR',
        letterSpacing: '.09rem',
        fontSize: '1.125rem',
        lineHeight: '2rem',
        color: '#fff'
      },
      button: {
        fontFamily: 'neuePlakB',
        fontSize: '.56rem',
        lineHeight: '1rem',
        letterSpacing: '.125rem'
      },
      episodeTitle2: {
        fontFamily: 'neuePlakB',
        fontSize: '.875rem',
        lineHeight: '1.375rem',
        letterSpacing: '.41rem',
        color: green
      },
      stat1: {
        fontFamily: 'neuePlakR',
        fontSize: '4rem',
        lineHeight: '4rem',
        letterSpacing: '.06rem'
      },
      stat2: {
        fontFamily: 'neuePlakR',
        fontSize: '.75rem',
        lineHeight: '1.3rem',
        letterSpacing: '.125rem'
      },
      subhead1: {
        fontFamily: 'neuePlakB',
        fontSize: '1rem',
        letterSpacing: '.125rem',
        lineHeight: '1.75rem'
      }
    }
  }
});
